angular.module('bmsApp.settings')
	.controller('SMHouseTemplateIndexCtrl',
		function ($scope, SMHouseTemplateSvc, $log, $state, $cookies, ngTableParams, notify, $q, AuthService) {

			var defaultTableParams = function () {
				return {
					page: 1, // show first page
					count: $scope.config.table.params.count, // count per page
					sorting: {
						label: 'asc' // initial sorting
					},
					filter: {
						search: ''
					}
				};
			};

			var initialIndexParams = function () {
				if (angular.isDefined($cookies.smHouseTemplateIndexParams)) {
					return angular.extend({}, defaultTableParams(), JSON.parse($cookies.smHouseTemplateIndexParams));
				}
				else {
					return angular.extend({}, defaultTableParams());
				}
			};

			function init() {
				var params = initialIndexParams();
				self.quoteFilters = angular.copy(params.filter);

				self.tableParams = new ngTableParams(params, {
					total: 0, // length of data
					counts: $scope.config.table.settings.counts, // available page counts
					getData: function ($defer, params) {
						SMHouseTemplateSvc.index(params.$params)
							.then(function (response) {
								params.total(response.data.house_template_filtered_count);
								$defer.resolve(response.data.house_template_collection);
								self.loading = false;
							});
					}
				});
			}

			// text search
			function filterChanged() {
				self.tableParams.$params.filter.search = self.searchText;
			}

			// Store the table params whenever anything changes
			$scope.$watch('tableParams.$params', function (value) {
				if (angular.isObject(value)) {
					$cookies.tgQuoteIndexParams = JSON.stringify(value);
				}
			}, true);
			
			function rowClicked(houseTemplate) {
				$state.go('main.settings.smHouseTemplatesIndex.update', {
					houseTemplateId: houseTemplate.id
				});
			}

			var self = $scope.SMHouseTemplateCtrl = {
				loading: true,
				methods: {
					init: init,
					rowClicked: rowClicked,
					filterChanged: filterChanged
				}
			};

		});



